import * as types from '../mutation-types'
import UserProfileService from '@/services/UserProfileService'

export const userProfileStore = {
  state: {
    userProfileLoaded: false,
    userProfile: {
      email: '',
      accounts: [],
      firstName: '',
      lastName: '',
      allPracticesDashboardOnLogin: false
    }
  },
  getters: {
    userProfileLoaded (state) {
      return state.userProfileLoaded
    },
    userProfile (state) {
      return state.userProfile
    },
    userProfileEmail (state) {
      return state.userProfile.email
    },
    userProfileAccounts (state) {
      return state.userProfile.accounts
    },
    userProfileFirstName (state) {
      return state.userProfile.firstName
    },
    userProfileLastName (state) {
      return state.userProfile.lastName
    },
    userProfileName (state) {
      if (state.userProfile.firstName) {
        return state.userProfile.firstName + ' ' + state.userProfile.lastName
      }
      return ''
    },
    userProfileAllPracticesDashboardOnLogin (state) {
      return state.userProfile.allPracticesDashboardOnLogin
    },
    userProfileHasPracticeAccount (state) {
      for (let i = 0; i < state.userProfile.accounts.length; i++) {
        if (state.userProfile.accounts[i].application === 'PRACTICE' && !state.userProfile.accounts[i].accountClosed) {
          return true
        }
      }
      return false
    },
    userProfileHasMoreThan1ActivePracticeAccount (state) {
      let count = 0
      for (let i = 0; i < state.userProfile.accounts.length; i++) {
        if (state.userProfile.accounts[i].application === 'PRACTICE' && !state.userProfile.accounts[i].accountClosed) {
          count++
        }
      }
      return count > 1
    }
  },
  mutations: {
    [types.UP_SET_PROFILE] (state, up) {
      state.userProfile = up
      state.userProfileLoaded = true
    },
    [types.UP_UPDATE_NAME] (state, name) {
      state.userProfile.firstName = name.firstName
      state.userProfile.lastName = name.lastName
    },
    [types.UP_UPDATE_ALL_PRACTICES_DASHBOARD_ON_LOGIN_SETTING] (state, setting) {
      state.userProfile.allPracticesDashboardOnLogin = setting
    }
  },

  actions: {
    [types.UP_UPDATE_NAME] (context, nameData) {
      context.commit(types.UP_UPDATE_NAME, nameData)
    },
    [types.UP_UPDATE_ALL_PRACTICES_DASHBOARD_ON_LOGIN_SETTING] (context, setting) {
      context.commit(types.UP_UPDATE_ALL_PRACTICES_DASHBOARD_ON_LOGIN_SETTING, setting)
    },
    [types.UP_SET_PROFILE] (context, up) {
      context.commit(types.UP_SET_PROFILE, up)
    },
    async [types.UP_LOAD_PROFILE] (context) {
      const response = await UserProfileService.getUserProfile()
      context.commit(types.UP_SET_PROFILE, response.data)
    }
  }
}
